import React from "react";
import { MessageCircle, X, Send } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

/**
 * Floating chat widget — extracted from InfoShopPage.jsx (v3.8.5). All
 * data-testid attributes (`chat-fab`, `chat-panel`, `chat-input`,
 * `chat-raise-support`) are preserved so the existing Playwright suite
 * keeps passing without modification.
 */
export default function ChatWidget({
  chatOpen,
  setChatOpen,
  chatMsgs,
  setChatMsgs,
  chatInput,
  setChatInput,
  onRaiseSupport,
}) {
  const sendMessage = () => {
    if (!chatInput.trim()) return;
    const u = chatInput.trim();
    setChatMsgs((p) => [
      ...p,
      { from: "user", text: u },
      {
        from: "bot",
        text:
          "Thanks — I'll route this to our team. For order issues or warranty claims, please raise a support request with your Order ID.",
      },
    ]);
    setChatInput("");
  };

  return (
    <>
      <button
        onClick={() => setChatOpen((s) => !s)}
        data-testid="chat-fab"
        className="fixed bottom-5 right-5 z-40 h-12 w-12 rounded-full bg-[#0072CE] hover:bg-[#005BA6] text-white shadow-lg flex items-center justify-center"
        aria-label="Open chat"
      >
        <MessageCircle size={20} />
      </button>

      {chatOpen && (
        <div
          data-testid="chat-panel"
          className="fixed bottom-20 right-5 z-40 w-80 max-h-[70vh] bg-white rounded-xl border border-slate-200 shadow-xl flex flex-col"
        >
          <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between">
            <div className="font-display font-semibold text-slate-900 text-sm">UniBuy™ Assistant</div>
            <button onClick={() => setChatOpen(false)} className="text-slate-400 hover:text-slate-900">
              <X size={14} />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-3 space-y-2">
            {chatMsgs.map((m, i) => (
              <div
                key={i}
                className={`max-w-[85%] rounded-lg px-3 py-2 text-sm leading-snug ${
                  m.from === "bot" ? "bg-slate-100 text-slate-800" : "bg-[#0072CE] text-white ml-auto"
                }`}
              >
                {m.text}
              </div>
            ))}
          </div>
          <div className="border-t border-slate-200 p-2 flex gap-2">
            <Input
              value={chatInput}
              onChange={(e) => setChatInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") sendMessage();
              }}
              data-testid="chat-input"
              placeholder="Type a message…"
              className="h-9 text-sm"
            />
            <Button
              onClick={onRaiseSupport}
              data-testid="chat-raise-support"
              className="h-9 bg-[#0072CE] hover:bg-[#005BA6] text-white text-xs"
            >
              <Send size={14} className="mr-1" /> Support
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
